import { render, staticRenderFns } from "./InformacionDelPrograma.vue?vue&type=template&id=4a7de2ed"
import script from "./InformacionDelPrograma.vue?vue&type=script&lang=js"
export * from "./InformacionDelPrograma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports